export const pollSelectedPhotos = async (
  sessionId,
  accessToken,
  setLoading,
  setData,
  setNextPageToken,
  setHasMore,
  nextPageToken = null
) => {
  const url = new URL('https://photospicker.googleapis.com/v1/mediaItems');
  url.searchParams.set('sessionId', sessionId);
  if (nextPageToken) {
    url.searchParams.set('pageToken', nextPageToken);
  }

  try {
    setLoading(true);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const data = await response.json();

    setData((prev) => [...prev, ...(data?.mediaItems || [])]);

    if (data?.nextPageToken) {
      setNextPageToken(data.nextPageToken);
      setHasMore(true);
    } else {
      setHasMore(false); // No more pages
    }
  } catch (err) {
    console.error('❌ Error fetching photos:', err);
    setHasMore(false);
  } finally {
    setLoading(false);
  }
};
